import React from 'react';
import PropTypes from 'prop-types';

const DollarSquareSvg = ({ color, width, height }) => {
  return (
    <svg
      width={`${width || 20}`}
      height={`${height || 20}`}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5003 18.3333H7.50033C3.33366 18.3333 1.66699 16.6667 1.66699 12.5V7.50001C1.66699 3.33334 3.33366 1.66667 7.50033 1.66667H12.5003C16.667 1.66667 18.3337 3.33334 18.3337 7.50001V12.5C18.3337 16.6667 16.667 18.3333 12.5003 18.3333Z" 
        fill="white"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path 
        d="M7.22656 11.9415C7.22656 13.0165 8.05156 13.8832 9.07656 13.8832H11.1682C12.0599 13.8832 12.7849 13.1249 12.7849 12.1915C12.7849 11.1749 12.3432 10.8165 11.6849 10.5832L8.32656 9.41653C7.66823 9.1832 7.22656 8.82486 7.22656 7.8082C7.22656 6.87486 7.95156 6.11653 8.84323 6.11653H10.9349C11.9599 6.11653 12.7849 6.9832 12.7849 8.0582" 
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path 
        d="M10 5V15"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

DollarSquareSvg.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default DollarSquareSvg;
